import React, {useEffect, useState} from "react";
import {S3SignedUrl} from "./s3Bucket";
import {Box} from "@mui/material";
import ReactDOM from "react-dom";

export const ImageCell = ({src, bucket}) => {
  const [isHovered, setIsHovered] = useState(false);
  const [coords, setCoords] = useState({top: 0, left: 0});
  const [signedUrl, setSignedUrl] = useState("");
  useEffect(() => {
    const generateSignedUrl = async () => {
      const key = src.replace("s3://benchmark-violation-videos/", "");
      try {
        const url = await S3SignedUrl(bucket, key)
        setSignedUrl(url);
      } catch (err) {
        console.error("Error generating signed image URL:", err);
      }
    };
    generateSignedUrl();
  }, []);

  const handleMouseEnter = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    setCoords({
      top: rect.top - rect.height - 105 + window.scrollY,
      left: rect.left + rect.width + 10 + window.scrollX,
    });
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  const hoverImage = (
    <Box
      sx={{
        position: "absolute",
        top: coords.top,
        left: coords.left,
        zIndex: 9999,
        p: 1,
        borderRadius: 2,
        backgroundColor: "#fff",
        boxShadow: "0 8px 24px rgba(0,0,0,0.25)",
        maxWidth: 640,
        maxHeight: 640,
      }}
    >
      <Box
        component="img"
        src={signedUrl}
        alt="Violation Full"
        sx={{
          width: "100%",
          height: "100%",
          objectFit: "contain",
          borderRadius: 2,
        }}
      />
    </Box>
  );

  return (
    <>
      <Box
        sx={{
          position: "relative",
          display: "inline-block",
          cursor: "pointer",
        }}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <Box
          component="img"
          src={signedUrl}
          alt="Violation Thumbnail"
          sx={{
            width: 50,
            height: 50,
            borderRadius: 1,
            objectFit: "cover",
            transition: "transform 0.3s ease",
            "&:hover": {
              transform: "scale(1.1)",
              boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.3)",
            },
          }}
        />
      </Box>
      {isHovered && ReactDOM.createPortal(hoverImage, document.body)}
    </>
  );
};